import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const relationsApi = {
  getStudentParents: (studentId) => api.get(`/relations/student/${studentId}`).then(unwrap),
  getParentStudents: (parentId) => api.get(`/relations/parent/${parentId}`).then(unwrap),
  getUnlinkedStudents: () => api.get('/relations/unlinked-students').then(unwrap),
  link: (data) => api.post('/relations/link', data).then(unwrap),
  bulkLink: (data) => api.post('/relations/bulk-link', data).then(unwrap),
  unlink: (data) => api.delete('/relations/unlink', { data }).then(unwrap),
}
